module.exports = __webpack_public_path__ + "img/login.a685f50f.jpg";